import { setTerm } from './helpers';

export const setElectronicTradingType = setTerm('electronic_trading');
